<template>
    <b-container>
        <router-link :to="{ name: 'my_students' }">&larr; Back to My Students</router-link>
        <b-alert
            class="mt-4"
            variant="secondary"
            :show="true"
        >
            <h2>Student Settings</h2>
            <p class="text-danger">
                <font-awesome-icon icon="exclamation-circle" class="mr-2" />
                Indicates required fields
            </p>
        </b-alert>
        <div class="mt-2">
            <b-card>
                <h3 class="card-title">{{ name }}'s Student Info</h3>

                <StudentFormFields
                    :student="student"
                    disabled
                />
                
                <div class="text-center mt-3">
                    <router-link
                        :to="{ name: 'parent_edit_student', params: { id: student.id } }"
                        class="sc-btn pill"
                    >
                        <font-awesome-icon icon="pencil-alt" class="mr-2" />
                        Edit Student
                    </router-link>
                </div>
            </b-card>
        </div>
        <b-card
            title="Delete Student"
            title-tag="h2"
            class="mt-2"
            variant="secondary"
        >
            <button
                @click="deleteStudent()"
                class="sc-btn btn-danger"
            >
                <font-awesome-icon icon="trash" class="mr-2" />
                Delete Student
            </button>
        </b-card>
    </b-container>
</template>
<script>
import { mapState } from 'vuex';
import StudentFormFields from './StudentFormFields.vue';

export default {
    components: { StudentFormFields },
    props: [ "id" ],
    data () {
        return {
            editStudentDisabled : true
        };
    },
    methods: {
        getPersonalInfo() {
            var info = this.student.personal_info;
            if (typeof info == "string") {
                return JSON.parse(info) || {};
            }
            return {};
        },
        deleteStudent() {
            this.$bvModal.msgBoxConfirm("Do you really want to delete this student?", {
                title           : "Please Confirm",
                size            : "lg",
                buttonSize      : "lg",
                okVariant       : "danger",
                okTitle         : "Confirm Delete",
                cancelTitle     : "Cancel Delete",
                footerClass     : "p-2",
                hideHeaderClose : false,
                centered        : true
            })
            .then((confirmed) => {
                if (confirmed) {
                    this.$api.post(
                        "/api/student/remove",
                        { student_id: this.id }
                    ).then((response) => {
                        const data = response.data;
                        if (data.removed) {
                            this.$router.push({ name: "my_students" });
                            this.$store.commit("removeStudent", { id: this.id });
                        }
                    });
                }
            });
        }
    },
    computed: {
        student () {
            if (!this.students) return null;
            return this.students.filter(s => s.id == this.id)[0];
        },
        name () {
            return `${this.student.first_name} ${this.student.last_name}`;
        },
        age () {
            return this.$moment().diff(this.student.birthdate, "years");
        },
        ...mapState([
                        "students",
                        "settings"
                    ])
    }
}
</script>